/* tslint:disable */
/* eslint-disable */
/**
 * Authentication-API
 * This API allows strong authentication with LuxTrust.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LightUserResponse
 */
export interface LightUserResponse {
    /**
     * technical id of esklepios user
     * @type {string}
     * @memberof LightUserResponse
     */
    esklepiosId?: string;
    /**
     * luxtrust matricule
     * @type {string}
     * @memberof LightUserResponse
     */
    ssn?: string;
    /**
     * user roles
     * @type {string}
     * @memberof LightUserResponse
     */
    roles?: string;
    /**
     * status of user
     * @type {string}
     * @memberof LightUserResponse
     */
    status?: string;
}

/**
 * Check if a given object implements the LightUserResponse interface.
 */
export function instanceOfLightUserResponse(value: object): value is LightUserResponse {
    return true;
}

export function LightUserResponseFromJSON(json: any): LightUserResponse {
    return LightUserResponseFromJSONTyped(json, false);
}

export function LightUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LightUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'esklepiosId': json['esklepiosId'] == null ? undefined : json['esklepiosId'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'roles': json['roles'] == null ? undefined : json['roles'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function LightUserResponseToJSON(json: any): LightUserResponse {
    return LightUserResponseToJSONTyped(json, false);
}

export function LightUserResponseToJSONTyped(value?: LightUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'esklepiosId': value['esklepiosId'],
        'ssn': value['ssn'],
        'roles': value['roles'],
        'status': value['status'],
    };
}

